/** Mirrors oem's MAX_TEXT_DISPLAY_LENGTH. */
const MAX_TEXT_DISPLAY_LENGTH = 75;

/**
 * Ported from oem's `utils/_initials` and `utils/index` so shared components
 * carry no oem dependency. oem re-exports these.
 */
export const trimText = (
  text?: string | null,
  maxLength: number = MAX_TEXT_DISPLAY_LENGTH,
): string | null => {
  if (!text) return null;
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};

export const pluralizeCount = (
  count: number,
  singular: string,
  plural: string,
): string => `${count} ${count === 1 ? singular : plural}`;
